import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
interface FooterProps {
  className?: string;
  view: string;
}

const Footer: React.FC<FooterProps> = ({ className,view }) => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const themeDetails = useSelector((state: RootState) => state.themes);
  const userDetails = useSelector((state: RootState) => state.auth);
  const info = userDetails?.clientVo

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{ top: "auto", bottom: 0, backgroundColor: "#059ca9"}}
      className={className}
    >
      <Toolbar
        variant="dense"
        sx={{
          minHeight: "30px",
          justifyContent: "right",
          textAlign: "center",
          color: "white",
          px: { xs: 2, sm: 4 }, 
        }}
      >
        {userDetails.isLogin && <Typography variant="body2" align="right"  sx={{ paddingRight: view === "Top"? '5%':"0%" }}>
          © {currentYear} {info?.description} All Rights Reserved.
        </Typography>}
      </Toolbar>
    </AppBar>
  );
}

export default Footer;